import{RP_SHIFT_MODEL_LIST, RP_SHIFT_PAGINATION, RP_SHIFT_SEARCH}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: RP_SHIFT_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: RP_SHIFT_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: RP_SHIFT_PAGINATION,
    payload
})

